import React from 'react';

export const GlassSpinner = ({ size = 24, className = '' }) => {
  return (
    <div
      className={`glass-spinner ${className}`}
      style={{
        width: size,
        height: size,
        border: `2px solid rgba(38, 184, 227, 0.15)`,
        borderTopColor: 'var(--glass-primary)',
        borderRadius: '50%',
        animation: 'glass-spin 0.8s linear infinite',
      }}
    />
  );
};